<template>
    <div v-if="islogin">

        <div v-if="member">
            <div class="member-rail-brand"><small>YAXUN MEMBER RESEARCH ROOM</small><b>亚讯会员研究室</b><span>账户 · 关注 · 订阅 · 球币服务</span></div>
            <div class="portrait" v-if="member">
                <div class="img"><img :src="member.portrait == ''?defimg:member.portrait" v-if="member"/></div>
                <div class="con">
                <div class="name">{{member.name}}</div>
                <div class="dsc">{{member.intro}}</div>
                </div>
            </div>
            <div class="mycoin" v-if="member">
                <div class="item">
                    <b>{{member.gold}}</b>
                    <div>球币 <em></em></div>
                </div>
                <div class="item">
                    <b>{{member.integral}}</b>
                    <div @click="showPopupbox">积分<van-icon name="question-o"></van-icon></div>
                </div>
            </div>
            <div class="mybox">
                <div class="pc">
                    <div v-for="c,i in visibleNavList" :key="i" :class="['item', $route.path===c.url?'active':'']">
                        <router-link :to="c.url"><MemberNavIcon :name="c.icon"/><span>{{c.name}}</span><van-badge :content="notice" v-if="c.notice && notice>0" class="nt" /></router-link>
                    </div>
                </div>
                <div class="wp">
                    <div v-for="c,i in visibleNavList" :key="i" :class="['item', $route.path===c.url?'active':'']">
                        <router-link :to="c.url"><MemberNavIcon :name="c.icon"/><span>{{c.name}}</span><van-badge :content="notice" v-if="c.notice && notice>0" class="nt" /></router-link>
                    </div>
                </div>
                <div class="item out" @click="tologout"><MemberNavIcon name="et"/><span>退出登录</span></div>
            </div>

            <van-popup position="bottom" v-model="showPopup" :duration=".3">
                <div class="popbox">
                    <div class="popboxtitle">积分说明</div>
                    <div class="popboxcon mypopcon">
                        <p class="t">积分使用方法</p>
                        <p>积分可兑换成球币进行消费，100积分=1球币</p>
                        <p></p>
                        <p class="t">通过以下方法可获得积分</p>
                        <p>1. 每日签到领取1-10个积分</p>
                        <p>2. 发布一场推介可获得10个积分，每日最多发布10场推介</p>
<!--                        <p>...</p>-->
                    </div>
                </div>
            </van-popup>
        </div>

        <div class="skeletonbx" v-else-if="loading">
            <van-skeleton row="5"></van-skeleton>
        </div>

        <div class="member-load-state" v-else>
            <div>会员资料暂未加载</div>
            <button type="button" @click="loadMember">重新加载</button>
        </div>

    </div>
    <div v-else>
        <div class="portrait portpcc">
            <div class="img img_s"><img :src="defimg"/></div>
            <div class="con">
                <router-link to="/login">请登录</router-link><span>/</span><router-link to="/register">注册</router-link></div>
        </div>
<!--        <div class="skeletonbx">-->
<!--        <van-skeleton row="5" row-width="100%" title="true"></van-skeleton>-->
<!--        </div>-->
    </div>


</template>

<script>
    import defPortrait from "../../assets/images/default-analyst-v3.jpg"
    import MemberNavIcon from "./MemberNavIcon"
    export default {
        name: "my",
        components: {MemberNavIcon},
        data (){
          return {
              notice: 0,
              member: null,
              defimg: defPortrait,
              islogin: false,
              isExpert: false,
              loading: false,
              showPopup: false,
              navList:[
                  {name:'我的推介', url:'/my/recommend', icon: 'tj', expertOnly: true},
                  {name:'我的售出', url:'/my/sale', icon: 'sc', expertOnly: true},
                  {name:'我的关注', url:'/my/follow', icon: 'fl'},
                  {name:'我的订阅', url:'/my/subscribe', icon: 'dy'},
                  {name:'交易记录', url:'/my/cost', icon: 'cz'},
                  {name:'我的消息', url:'/my/notice', icon: 'mg', notice: true},
                  {name:'在线充值', url:'/my/recharge', icon: 'rc'},
                  {name:'提现兑换', url:'/my/tixian', icon: 'tx'},
                  {name:'账号管理', url:'/my/info', icon: 'in'}
              ]
          }
        },
        computed: {
            visibleNavList(){
                return this.navList.filter(item => !item.expertOnly || this.isExpert)
            }
        },
        watch: {
            '$store.state.token': {
                immediate: true,
                handler(token){ this.syncMember(token) }
            },
            '$store.state.notice'(notice){ this.notice = notice }
        },
        created() {
        },
        methods: {
            syncMember(token){
                this.notice = this.$store.state.notice
                if(!token){
                    this.islogin = false
                    this.isExpert = false
                    this.member = null
                    return
                }
                this.islogin = true
                this.loadMember()
            },
            loadMember(){
                let that = this
                this.loading = true
                this.$post(that.$api.memberinfo).then(function (res) {
                    if (res.code === 1){
                        let data = res.data.member
                        if(data.portrait === null)
                            data.portrait = ''
                        else
                            data.portrait = that.$api.imgBaseUrl + data.portrait
                        that.isExpert = Boolean(data.is_expert)
                        that.member = data
                    } else if (res.code === 1002) {
                        that.islogin = false
                        that.member = null
                    }
                }).catch(function () {
                    that.member = null
                }).finally(function () {
                    that.loading = false
                })
            },
            showPopupbox(){
                this.showPopup = true
            },
            tologout() {
                let that = this
                that.$dialog.confirm({
                    title: '确认',
                    message: '确定退出登录？',
                }).then( () => {
                    that.$store.commit('LOGOUT')
                    location.reload()
                }).catch( () => {
                    //no fun
                })
            }
        }
    }
</script>

<style scoped>
    .mypopcon{text-align: left;font-size:14px;padding:10px 30px 30px 30px;}
    .mypopcon p{line-height: 1.6rem;}
    .mypopcon p.t{margin-top:.6rem;color:#f60;}
    .member-load-state{padding:26px 18px;text-align:center;color:#71899b;background:#fff;}
    .member-load-state button{margin-top:12px;padding:7px 18px;border:0;border-radius:5px;color:#fff;background:#168fd5;cursor:pointer;}
</style>
